module.exports = __webpack_public_path__ + "static/media/shop.d9f36707.png";